import { render, staticRenderFns } from "./VerifiedAssessmentImportV5.vue?vue&type=template&id=0cbfdb0e&"
import script from "./VerifiedAssessmentImportV5.vue?vue&type=script&lang=ts&"
export * from "./VerifiedAssessmentImportV5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports